// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICredit } from './ICredit';
import {
    ICreditFromJSON,
    ICreditFromJSONTyped,
    ICreditToJSON,
    ICreditToJSONTyped,
} from './ICredit';

/**
 * 
 * @export
 * @interface IAccountRequest
 */
export interface IAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof IAccountRequest
     */
    type: IAccountRequestTypeEnum;
    /**
     * 
     * @type {ICredit}
     * @memberof IAccountRequest
     */
    credit: ICredit;
}

/**
* @export
* @enum {string}
*/
export enum IAccountRequestTypeEnum {
    CREDIT = 'CREDIT',
    PREPAID = 'PREPAID',
    ACH = 'ACH',
    LOYALTY = 'LOYALTY',
    PAYPAL = 'PAYPAL',
    MASTERPASS = 'MASTERPASS',
    VENMO = 'VENMO',
    THREEDSECURE = 'THREEDSECURE',
    VAULTED_ACCOUNT = 'VAULTED_ACCOUNT',
    FLEET = 'FLEET',
    APPLE_PAY = 'APPLE_PAY',
    SAMSUNG_PAY = 'SAMSUNG_PAY',
    GOOGLE_PAY = 'GOOGLE_PAY',
    MONEYNETWORK = 'MONEYNETWORK',
    EBT = 'EBT'
}


/**
 * Check if a given object implements the IAccountRequest interface.
 */
export function instanceOfIAccountRequest(value: object): value is IAccountRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('credit' in value) || value['credit'] === undefined) return false;
    return true;
}

export function IAccountRequestFromJSON(json: any): IAccountRequest {
    return IAccountRequestFromJSONTyped(json, false);
}

export function IAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'credit': ICreditFromJSON(json['credit']),
    };
}

export function IAccountRequestToJSON(json: any): IAccountRequest {
    return IAccountRequestToJSONTyped(json, false);
}

export function IAccountRequestToJSONTyped(value?: IAccountRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'credit': ICreditToJSON(value['credit']),
    };
}

